@if(customField()) {
<label class="loren-file-upload-custom-field" [for]="id()">
  <span class="loren-file-upload-custom-field-label">{{ label() }}</span>
  <div class="loren-file-upload-custom-field-button">
    <mat-icon>upload</mat-icon>
  </div>
  <input
    #file
    class="loren-file-upload-hidden"
    type="file"
    [accept]="allowedFileTypes()"
    [id]="id()"
    [hidden]="renderAsHidden()"
    (change)="onFileChanged($event)" />
</label>
} @else {
<input
  [hidden]="renderAsHidden()"
  #file
  type="file"
  [accept]="allowedFileTypes()"
  (change)="onFileChanged($event)" />

}
